import { createContext as e } from "react";
const o = e({
  index: "",
  data: [],
  categories: [],
  categoryColors: /* @__PURE__ */ new Map(),
  setActiveLegend: () => {
  },
  setIsTooltipActive: () => {
  },
  selectCategory: () => {
  }
});
export {
  o as ChartCoreContext
};
